<template>
  <!-- Main con id="create-item-page" e la classe .page-container -->
  <main id="create-item-page" class="page-container">
    <!-- Messaggi di errore/successo -->
    <!-- <p
      v-if="errorMessage"
      :class="{ 'error-message': true, show: errorMessage }"
    >
      {{ errorMessage }}
    </p>
    <p
      v-if="successMessage"
      :class="{ 'success-message': true, show: successMessage }"
    >
      {{ successMessage }}
    </p> -->

    <!-- Form principale -->
    <section class="edit-layout stacked">
      <form class="create-item-form" @submit.prevent="onCreateItem">
        <!-- Nome Articolo -->
        <div class="create-item-row">
          <!-- Modello -->
          <div class="field">
            <label for="item-model">Modello</label>
            <input
              id="item-model"
              type="text"
              v-model="formData.model"
              placeholder="inserisci"
            />
          </div>

          <div class="field">
            <label for="item-name">Nome articolo</label>
            <input
              id="item-name"
              type="text"
              v-model="formData.itemName"
              placeholder="inserisci"
              required
            />
          </div>

          <!-- Categoria -->
          <div class="field">
            <label for="item-category">Categoria</label>
            <input
              id="item-category"
              type="text"
              v-model="formData.category"
              placeholder="inserisci"
              required
            />
          </div>

          <!-- Quantità -->
          <div class="field">
            <label for="quantity">Quantità</label>
            <input
              id="quantity"
              type="text"
              v-model="formData.quantity"
              placeholder="inserisci"
              required
            />
          </div>

          <!-- Data inserimento -->
          <div class="field">
            <label for="date">Data inserimento</label>
            <input
              id="date"
              type="date"
              v-model="formData.entryDate"
              placeholder="inserisci"
            />
          </div>

          <!-- Immagine -->
          <div class="field file-field">
            <label for="image">
              {{ imageFileName ? "Immagine caricata" : "Carica un'immagine" }}
            </label>

            <div class="custom-file">
              <input
                id="image"
                type="file"
                @change="handleImageUpload"
                accept="image/*"
                class="visually-hidden"
              />
              <label class="choose-btn" for="image">Scegli file</label>
              <span v-if="selectedFileName" class="file-name">
                {{ selectedFileName }}
              </span>
              <span
                v-else-if="formData.image && typeof formData.image === 'string'"
                class="file-name existing"
              >
                File già caricato: {{ imageFileName }}
              </span>
              <span v-else class="file-name placeholder">
                Nessun file selezionato
              </span>
            </div>
          </div>

          <!-- Bottone "Salva" -->
          <div class="save-button-container">
            <button id="create-item-button" type="submit">Salva</button>
          </div>
        </div>

        <hr />
      </form>
    </section>
  </main>
</template>

<script>
import { mapActions } from "vuex/dist/vuex.cjs.js";
import { useToast } from "vue-toast-notification";

export default {
  setup() {
    const toast = useToast();
    return { toast };
  },
  name: "CreateItemPage",
  data() {
    return {
      formData: {
        model: "",
        itemName: "",
        category: "",
        quantity: "",
        entryDate: "",
        image: null,
      },
      // errorMessage: "",
      // successMessage: "",
      selectedFileName: "",
    };
  },
  computed: {
    // Se formData.image è una stringa (URL), estrai il nome del file
    imageFileName() {
      if (this.formData.image && typeof this.formData.image === "string") {
        return this.formData.image.split("/").pop();
      }
      return "";
    },
  },
  methods: {
    ...mapActions(["uploadImage", "createItem"]),
    handleImageUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.formData.image = file;
        this.selectedFileName = file.name;
      }
    },
    async onCreateItem() {
      // this.errorMessage = "";
      // this.successMessage = "";
      try {
        let imageUrl = "";
        // Se è presente un'immagine, effettua prima l'upload tramite lo store
        if (this.formData.image) {
          const uploadResponse = await this.$store.dispatch("uploadImage", {
            image: this.formData.image,
          });
          imageUrl = uploadResponse.data.url;
        }

        // Prepara il payload per creare l'item, includendo l'URL permanente dell'immagine
        const itemPayload = {
          model: this.formData.model,
          itemName: this.formData.itemName,
          category: this.formData.category,
          quantity: this.formData.quantity,
          entryDate: this.formData.entryDate,
          image: imageUrl,
        };

        const response = await this.$store.dispatch("createItem", itemPayload);
        if (response.status === 200 || response.status === 201) {
          // this.$nextTick(() => {
          // this.successMessage =
          this.toast.success(
            response.data?.message || "Articolo creato con successo!"
          );
          // });
          // Resetta i campi (aggiorna eventualmente anche model, category ecc. se necessario)
          this.formData = {
            model: "",
            itemName: "",
            category: "",
            quantity: "",
            entryDate: "",
            image: null,
          };
          // redirect alla pagina items
          setTimeout(() => {
            this.$router.push({ name: "stock" });
          }, 1000);
        }
      } catch (error) {
        if (error.response?.status === 409) {
          // this.$nextTick(() => {
          // this.errorMessage =
          this.toast.error(
            error.response.data?.details ||
              "Conflitto nei dati, chiave univoca 'Nome articolo' già presente."
          );
          // });
        } else {
          // this.$nextTick(() => {
          // this.errorMessage =
          this.toast.error(
            error.response?.data?.details ||
              error.response?.data?.error ||
              "Errore durante l'aggiunta dell'articolo."
          );
          // });
        }
        // this.successMessage = "";
      }
    },
  },
};
</script>

<style src="@/css/CreateItemPage.css"></style>
